import { render, staticRenderFns } from "./TextDetailBody.vue?vue&type=template&id=7cee9f7c"
import script from "./TextDetailBody.vue?vue&type=script&lang=js"
export * from "./TextDetailBody.vue?vue&type=script&lang=js"
import style0 from "./TextDetailBody.vue?vue&type=style&index=0&id=7cee9f7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports